document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.animate,.lux-card,.trust-lux-item,.review,.check,.lineup-product').forEach(el => el.classList.add('animate'));
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: .12 });
  document.querySelectorAll('.animate').forEach(el => io.observe(el));

  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
      mobileMenu.classList.toggle('is-open', !open);
    });
  }

  const productSection = document.querySelector('.product-main');
  if (productSection) {
    const data = productSection.querySelector('[data-product-variants]');
    const variants = data ? JSON.parse(data.textContent) : [];
    const optionSelects = [...productSection.querySelectorAll('[data-option-position]')];
    const variantSelect = productSection.querySelector('[data-variant-id]');
    const price = productSection.querySelector('[data-product-price]');
    const button = productSection.querySelector('[data-add-to-cart]');
    const image = productSection.querySelector('[data-product-image]');

    const syncVariant = () => {
      if (!optionSelects.length || !variantSelect) return;
      const selected = optionSelects.map(s => s.value);
      const variant = variants.find(v => v.options.every((value, index) => value === selected[index]));
      if (!variant) {
        button.disabled = true;
        button.textContent = 'Unavailable';
        return;
      }
      variantSelect.value = String(variant.id);
      const option = variantSelect.querySelector(`option[value="${variant.id}"]`);
      if (option && price) price.textContent = option.dataset.price;
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      if (option && option.dataset.image && image) image.src = option.dataset.image;
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };

    optionSelects.forEach(select => select.addEventListener('change', syncVariant));
  }

  document.querySelectorAll('[data-fake-verify]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const panel = document.querySelector('[data-verify-result]');
      if (panel) panel.style.display = 'grid';
    });
  });
});

// Researcher verification gate
(() => {
  const gate = document.querySelector('[data-researcher-gate]');
  if (!gate) return;
  const age = gate.querySelector('[data-gate-age]');
  const researcher = gate.querySelector('[data-gate-researcher]');
  const enter = gate.querySelector('[data-gate-enter]');
  const key = 'enhanced_researcher_verified_v1';

  let verified = false;
  try { verified = localStorage.getItem(key) === 'true'; } catch (e) {}
  if (verified) return;

  gate.hidden = false;
  document.body.classList.add('researcher-gate-open');

  const sync = () => { enter.disabled = !(age.checked && researcher.checked); };
  age.addEventListener('change', sync);
  researcher.addEventListener('change', sync);
  enter.addEventListener('click', () => {
    if (enter.disabled) return;
    try { localStorage.setItem(key, 'true'); } catch (e) {}
    gate.hidden = true;
    document.body.classList.remove('researcher-gate-open');
  });
})();
